import { render, staticRenderFns } from "./GrossProfit.vue?vue&type=template&id=6acc8994&scoped=true"
import script from "./GrossProfit.vue?vue&type=script&lang=js"
export * from "./GrossProfit.vue?vue&type=script&lang=js"
import style0 from "./GrossProfit.vue?vue&type=style&index=0&id=6acc8994&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc8994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acc8994')) {
      api.createRecord('6acc8994', component.options)
    } else {
      api.reload('6acc8994', component.options)
    }
    module.hot.accept("./GrossProfit.vue?vue&type=template&id=6acc8994&scoped=true", function () {
      api.rerender('6acc8994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/GrossProfit.vue"
export default component.exports